import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '../index';

export const configsSelector = (state: RootState) => state.configs.data;

export const nationalCurrencySelector = (state: RootState) => state.configs.data?.nationalCurrency || '';

export const receiptUrlSelector = (state: RootState) => state.configs.data?.externalPaymentReceiptUrl;

export const counterReceiptUrlSelector = (state: RootState) => state.configs.data?.externalPaymentCounterUrl;

export const attachedDocMaxSizeSelector = (state: RootState) => state.configs.data?.['lpco.attdoc.maxSizeMB'] || 2;

export const attachedDocExtensionsSelector = createSelector(
  (state: RootState) => state.configs.data?.['lpco.attdoc.allowedExtensions'],
  (allowedExtensions) => {
    if (allowedExtensions) {
      return allowedExtensions
        .toUpperCase()
        .split(/[^a-z]+/i)
        .filter(Boolean);
    }

    return null;
  }
);

export const invoiceUrlSelector = (state: RootState) => state.configs.data?.invoiceUrl;

export const defaultScaleSelector = (state: RootState) => state.configs.data?.defaultScale;
